exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#crop-capture-modal--package-capture___BV_modal_outer_ {\n\tz-index: 1142 !important;\n}\n", ""]);

// exports
